'use strict';

const { consoleSandbox } = require('@sentry/utils');
let processInclude = require('base/util');
const sizeSelect = require('./product/sizeSelect');
require('./product/colorSwatches');
require('./product/detail');

let updatedPid = '';
let newUuid='';
let clickedSize = '';
let clickedColor = '';
let clickedProduct = '';
let clickedImage = '';
let currentOpenedModal = '';

require('core/components/spinner');

function compileImageTemplate(template, img, index) {
  const productSlide = template.cloneNode(true);
  productSlide.dataset.index = index;
  const mask = productSlide.querySelector('.mm-mask-9x16-');
  if (mask) {
    const maskNumber = () => (Math.floor(Math.random() * (10 - 1) + 1)).toString();
    mask.classList.remove('mm-mask-9x16-');
    mask.classList.add(`mm-mask-9x16-${maskNumber()}`);
  }
  const productImg = productSlide.querySelector('img');
  productImg.dataset.zoomImg = img.url;
  productImg.alt = img.alt;
  let srcSetString = '';
  productImg.dataset.srcset.split(',').forEach((w,i) => {
    if (w.includes('x')){
      const width = productImg.dataset.formats.split(',')[i]; //get the first numeric part
      const retina = w.match(/(\d+)x/)[1]; //get the numeric part before 'x'
      srcSetString += `${img.dis[width]} ${retina}x,`
    } else if (w.includes('w')){
      const width = w.match(/(\d+)w/)[1];; //get the numeric part before 'w'
      srcSetString += `${img.dis[width]} ${width}w,`
    }
  });
  productImg.dataset.srcset = srcSetString;
  productImg.srcset = srcSetString;
  return productSlide;
}
const isMargiela = document.querySelector('body').classList.contains('Margiela');

let bodyMeasurementSwitchButtons;
let productMeasurementSwitchButtons;

function columnAndRowHighlight () {
  const tds = document.querySelectorAll('.modal-content-gudielines .size-guidelines-types-item .table tbody tr td');
  // const trs = document.querySelectorAll('.modal-content-gudielines .size-guidelines-types-item .table tbody tr');
  const ths = document.querySelectorAll('.modal-content-gudielines .size-guidelines-types-item .table thead tr th');
  [...tds, ...ths].forEach((td, i) => {
    td.addEventListener('mouseover', (e) => {
      const currentRow = e.target.closest('tr');
      currentRow.classList.add('hightlighet-table-element');
      const currentRowHeight = currentRow.offsetHeight;
      currentRow.style.height = currentRowHeight + 'px';
      const newIndex = [...e.target.parentElement.children].indexOf(e.target);
      const trsToBeHighLighted = e.target.closest('table').querySelectorAll(`tr > :nth-child(${newIndex + 1})`);
      trsToBeHighLighted.forEach(el => el.classList.add('hightlighet-table-element'));
      const tbodyHighLightedCells = document.querySelectorAll('.modal-content-gudielines tr .hightlighet-table-element');
      addRemoveTbodyLightedCellClass(tbodyHighLightedCells, 'add');
    });
    td.addEventListener('mouseleave', (e) => {
      const currentRow = e.target.closest('tr');
      currentRow.classList.remove('hightlighet-table-element');
      const newIndex = [...e.target.parentElement.children].indexOf(e.target);
      const trsToBeHighLighted = e.target.closest('table').querySelectorAll(`tr > :nth-child(${newIndex + 1})`);
      trsToBeHighLighted.forEach(el => el.classList.remove('hightlighet-table-element'));
      const tbodyHighLightedCells = document.querySelectorAll('.modal-content-gudielines tr .hightlighet-table-element');
      addRemoveTbodyLightedCellClass(tbodyHighLightedCells, 'remove');
    });
  });
}


// get first and last elements from tbody
function addRemoveTbodyLightedCellClass(tbodyHighLightedCells, act) {
  tbodyHighLightedCells.forEach((cell, index) => {
    if(act === 'remove') {
      document.querySelectorAll('.first-highlighted') && document.querySelectorAll('.first-highlighted').forEach(el => {
        el.classList.remove('first-highlighted');
      });
      document.querySelectorAll('.last-highlighted') && document.querySelectorAll('.last-highlighted').forEach(el => {
        el.classList.remove('last-highlighted');
      });
    } else {
      if(index === 0){
        cell.classList.add('first-highlighted');
      } else if(index === tbodyHighLightedCells.length -1) {
        cell.classList.add('last-highlighted');
      }
    }
  });
}

function hideShowUnits(unit) {
  const modal = document.querySelector('#size-guidelines-modal');
  const displayValues = [...modal.querySelectorAll('.js-value')];
  displayValues.forEach((item) => {
    if (item.classList.contains(`js-${unit}`)) {
      item.classList.remove('d-none');
    } else {
      item.classList.add('d-none');
    }
  });
}

function sizeUnitToggler() {
  const modal = document.querySelector('#size-guidelines-modal');
  if (modal) {
    const muTogglers = [...modal.querySelectorAll('input[name="measuringguide_mu"]')];
    muTogglers.forEach((item) => {
      let unit = item.checked ? 'in' : 'cm';
      hideShowUnits(unit);
      item.addEventListener('change', (e) => {
        unit = e.currentTarget.checked ? 'in' : 'cm';
        hideShowUnits(unit);
        muTogglers.forEach((toggler) => {
          toggler.checked = e.currentTarget.checked;
        });
      });
    });
  }
}

document.querySelectorAll('.fitguide__tab-button').forEach((item) => {
  item.addEventListener('click', (event) => {
    if (item.dataset.ref === 'fitguide-content-01') {
      document.getElementById('fitguide-content-01').style.display = 'block';
      document.getElementById('fitguide-content-02').style.display = 'none';
    }
    if (item.dataset.ref === 'fitguide-content-02') {
      document.getElementById('fitguide-content-01').style.display = 'none';
      document.getElementById('fitguide-content-02').style.display = 'block';
    }
  });
});

if (document.querySelector('.click-to-convert-sizes-text')) {
  document.querySelector('.click-to-convert-sizes-text').addEventListener('click', (event) => {
    document.getElementById('fitguide-content-01').style.display = 'none';
    document.getElementById('fitguide-content-02').style.display = 'block';
    document.getElementById('fitguide-measurement-button').classList.remove('fitguide__tab-button--active');
    document.getElementById('fitguide-sizes-button').classList.add('fitguide__tab-button--active');
  });
}

document.querySelectorAll('.fitguide__tab-button').forEach((item) => {
  const container = document.querySelector('#size-guidelines-modal .modal-content');
  if (container) {
    let tabs = [...container.querySelectorAll('.fitguide__tab-button')];
    tabs.forEach((items) => {
      items.addEventListener('click', (event) => {
        const thisItem = event.currentTarget;
        if (!thisItem.classList.contains('fitguide__tab-button--active')) {
          [...container.querySelectorAll('.fitguide__tab-button--active')].forEach((item) => {
            item.classList.remove('fitguide__tab-button--active');
          });
          [...container.querySelectorAll('.fitguide__content')].forEach((item) => {
            item.classList.remove('fitguide__content--active');
          });
          thisItem.classList.add('fitguide__tab-button--active');
          [...container.querySelectorAll(`[data-ref="${thisItem.dataset.ref}"]`)].forEach((item) => {
            item.classList.add('fitguide__tab-button--active');
          });
        }
      });
    });
    const sizeSelectors = [...container.querySelectorAll('.measuring-guide__size-selector select')];
    sizeSelectors.forEach((item) => {
      item.addEventListener('change', (e) => {
        const [type, size] = e.currentTarget.value.split('_');
        let lengthValue = size;
        if (type === 'size') {
          container.querySelector(`.measuring-guide__interactive-table[data-measure="${type}"]:not(.d-none)`).classList.add('d-none');
          container.querySelector(`[data-measure="${type}"][data-size="${size}"]`).classList.remove('d-none');
          const lenghtSelect = container.querySelector('.measuring-guide__size-selector select[name="length"]');
          if (lenghtSelect) {
            lengthValue = lenghtSelect.value.split('_')[1];
          }
        }
        [...container.querySelectorAll(`.measuring-guide__interactive-table:not(.d-none) [data-length]:not([data-length="${lengthValue}"])`)].forEach((item) => {
          item.classList.add('d-none');
        });
        container.querySelector(`.measuring-guide__interactive-table:not(.d-none) [data-length="${lengthValue}"]`).classList.remove('d-none');
      });
    });
  }
});

function enhancedMeasuringGuide() {
  sizeUnitToggler();
  const container = document.querySelector('#size-guidelines-modal .modal-content');
  if (container) {
    let tabs = [...container.querySelectorAll('.fitguide__tab-button')];
    tabs.forEach((items) => {
      items.addEventListener('click', (event) => {
        const thisItem = event.currentTarget;
        if (!thisItem.classList.contains('fitguide__tab-button--active')) {
          [...container.querySelectorAll('.fitguide__tab-button--active')].forEach((item) => {
            item.classList.remove('fitguide__tab-button--active');
          });
          [...container.querySelectorAll('.fitguide__content')].forEach((item) => {
            item.classList.remove('fitguide__content--active');
          });
          thisItem.classList.add('fitguide__tab-button--active');
          [...container.querySelectorAll(`[data-ref="${thisItem.dataset.ref}"]`)].forEach((item) => {
            item.classList.add('fitguide__tab-button--active');
          });
        }
      });
    });
    const sizeSelectors = [...container.querySelectorAll('.measuring-guide__size-selector select')];
    sizeSelectors.forEach((item) => {
      item.addEventListener('change', (e) => {
        const [type, size] = e.currentTarget.value.split('_');
        let lengthValue = size;
        if (type === 'size') {
          container.querySelector(`.measuring-guide__interactive-table[data-measure="${type}"]:not(.d-none)`).classList.add('d-none');
          container.querySelector(`[data-measure="${type}"][data-size="${size}"]`).classList.remove('d-none');
          const lenghtSelect = container.querySelector('.measuring-guide__size-selector select[name="length"]');
          if (lenghtSelect) {
            lengthValue = lenghtSelect.value.split('_')[1];
          }
        }
        [...container.querySelectorAll(`.measuring-guide__interactive-table:not(.d-none) [data-length]:not([data-length="${lengthValue}"])`)].forEach((item) => {
          item.classList.add('d-none');
        });
        container.querySelector(`.measuring-guide__interactive-table:not(.d-none) [data-length="${lengthValue}"]`).classList.remove('d-none');
      });
    });
  }
}

function basicMeasuringGuide() {
  sizeUnitToggler();
}

function buildSingleRowContent(measure) {
  let content = '';
  if(measure && measure.values) {
    measure.values.forEach( val => {
      content += `
        <td class="js-values">
          ${val.cm ? `<span class="js-value js-cm">${val.cm}</span>` : null}
          ${val.in ? `<span class="js-value js-in d-none">${val.in}</span>` : null}
        </td>
      `
    })
  }
  return content;
}

const calcDynamicPercentWidth = (ref, length) => ``;

function buildTableHeader(bodyMeasurement) {
  let headings = '';
  if(bodyMeasurement && bodyMeasurement.headings) {
    bodyMeasurement.headings.forEach((el, index) => {
      headings += `<th style="width: ${calcDynamicPercentWidth(100, bodyMeasurement.headings.length)}" class="${index === 1 ? 'fixed-side' : ''}">${el}</th>`;
    });
  }
  return headings;
}

function buildTableBody(bodyMeasurement) {
  let content = '';
  if(bodyMeasurement && bodyMeasurement.convertedMeasurements) {
    bodyMeasurement.convertedMeasurements.forEach((measure) => {
      content += `
        <tr>
          <td class="measure-label label fixed-side">${measure.label}</td>
          ${buildSingleRowContent(measure)}
        </tr>
      `
    })
  }
  return content;
}

const initUnitSizeChangeBehaviour = (unitSizeInputs) => {
  const toggleActiveButton = (input) => {
    unitSizeInputs && unitSizeInputs.forEach(b => b.classList.remove('-active'));
    input.target.closest('.jils-change-unit-measure').classList.add('-active');
  }
  unitSizeInputs ? unitSizeInputs.forEach(b => b.addEventListener('click', (e) => toggleActiveButton(e))) : null;
}


const bodyMeasurementTemplate = (bodyMeasurement) => {
  const changeUnitMeasureLabel = `<div class="change-unit-measure-label">${bodyMeasurement && bodyMeasurement.measurementsDescriptionLabel}</div>`;
  const changeUnitMeasureSeparator = `<div class="change-unit-measure-separator">/</div>`;
  return `
    <header class="measuring-guide__header">
      <div class="measuring-guide__header-content">
        <p class="text-measurements-guide">${bodyMeasurement.description}</p>    
      </div>
      <div class="measuring-guide__toggler">
        <div class="col">
          <div class="row choose-size-radio-input-row">
            <div class="col-auto measuring-guide__radio-input -jils-measuring-guide-input">
              <div class="form-group mm-switch -md" id="body-measurements-switch">
                <div class="radio mm-switch__toggle jils-change-unit-measure -active">
                  <label for="unit-measure_0">cm
                    <input name="unit-measure" class="body-unit-measure unit-measure" id="unit-measure_0" type="radio" value="cm" checked="">
                  </label>
                </div>
                <div class="radio mm-switch__toggle jils-change-unit-measure">
                  <label for="unit-measure_1">inches
                    <input name="unit-measure" class="body-unit-measure unit-measure" id="unit-measure_1" type="radio" value="in">
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="measuring-guide-content row">
      <div class="col-12">
        <div class="table table-wrapper">
          <table class="table table-striped body-measure-table">
            <thead>
              ${buildTableHeader(bodyMeasurement)}
            </thead>
            <tbody>
              ${buildTableBody(bodyMeasurement)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `
}

const toggleButtonClick = (btn) => {
  if(btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      let selectedUnitMeasure = e.target && e.target.classList.contains('unit-measure') ? e.target.value : e.target.querySelector('.unit-measure').value;
      let selectedFitGuideSection = e.target.closest('.form-group.mm-switch').getAttribute('id');
      const isBodyMeasurementSection = selectedFitGuideSection === 'body-measurements-switch';
      const isProductMeasurementSection = selectedFitGuideSection === 'product-measurements-switch';

      if(isProductMeasurementSection) {
        productMeasurementSwitchButtons.forEach(b => b.classList.remove('-active'));
      } else if(isBodyMeasurementSection) {
        bodyMeasurementSwitchButtons.forEach(b => b.classList.remove('-active'));
      }
      
      e.target.closest('.mm-switch__toggle').classList.add('-active');

      if(selectedUnitMeasure) {
        if(selectedUnitMeasure == 'in') {
          if(isBodyMeasurementSection) {
            document.querySelectorAll('.body-measure-table tbody .js-values .js-cm').forEach(cms => {
              cms.classList.contains('d-none') ? null : cms.classList.add('d-none');
            });
            document.querySelectorAll('.body-measure-table tbody .js-values .js-in').forEach(ins => {
              ins.classList.remove('d-none');
            });
          } else if (isProductMeasurementSection) {
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-cm').forEach(cms => {
              cms.classList.contains('d-none') ? null : cms.classList.add('d-none');
            });
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-in').forEach(ins => {
              ins.classList.remove('d-none');
            });
          }
        } else {
          if(isBodyMeasurementSection) {
            document.querySelectorAll('.body-measure-table tbody .js-values .js-in').forEach(ins => {
              ins.classList.contains('d-none') ? null : ins.classList.add('d-none');
            });
            document.querySelectorAll('.body-measure-table tbody .js-values .js-cm').forEach(cms => {
              cms.classList.remove('d-none');
            });
          } else if (isProductMeasurementSection) {
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-in').forEach(ins => {
              ins.classList.contains('d-none') ? null : ins.classList.add('d-none');
            });
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-cm').forEach(cms => {
              cms.classList.remove('d-none');
            });
          }
        }
      }
    })
  }

}

function updateImages(product) {
  const productData = product.defaultVariant ? product.defaultVariant : product;
  const productSlideTemplate = document.querySelector('#carousel-image-template .product-slide');
  const productThumbTemplate = document.querySelector('#carousel-thumb-template .product-slide');
  const imagesWrapper = document.querySelector('.image-carousel-col .swiper-wrapper');

  const imagesthumbWrapper = document.querySelector('.thumbs-carousel-col .swiper-wrapper');
  
  imagesWrapper.innerHTML = '';

  const thumbsWrapper =  document.querySelector('.thumbs-carousel-col .swiper-wrapper');
  const selectedThumb =  Array.from(thumbsWrapper.querySelectorAll('.swiper-slide')).find(e => e.classList.contains('selected'));
  const selectedThumbIndex = selectedThumb ? selectedThumb.dataset.index : 0;
  thumbsWrapper.innerHTML = '';

  imagesthumbWrapper.innerHTML = '';
  productData.swipeableImages.large.forEach((img, index) => {
    imagesWrapper.append(compileImageTemplate(productSlideTemplate, img, index));
    imagesthumbWrapper.append(compileImageTemplate(productThumbTemplate, img, index));

  });

  // IBT-3745
  const imagesWrappers = document.querySelector('.image-carousel-col').querySelectorAll('.swiper-wrapper');
  imagesWrappers.forEach(element => {
    if (element === imagesWrapper) return;
    element.innerHTML = imagesWrapper.innerHTML;
  });

  //TODO: Check Marni for video and editorial images
  if (isMobile()){
    imagesWrappers.forEach(element => {
      const swiper = element.closest('.swiper').swiper;
      swiper && swiper.update();
    });
  } else {
    thumbsWrapper.querySelector(`[data-index="${selectedThumbIndex}"]`).classList.add('swiper-slide-active');

    const swiper = thumbsWrapper.closest('.swiper').swiper;
    if (swiper.slides.length > 3) {
      swiper.init();
      swiper.update();
    } else {
      swiper.destroy(false, true);
    }

    // scrollBehavior.bindEvents();
  }
}


function bindEventOpenFitGuide() {
  $('.size-guidelines-button').on('click', function (e) {
    const sizeConversionAccordion = document.querySelector('.accordion.size-conversion-accordion');
    const bodyMeasuresAccordion = document.querySelector('.accordion.body-measures-accordion');
    const productMeasuresAccordion = document.querySelector('.accordion.product-measures-accordion');
    const genderSizeConversionAccordion = document.querySelector('.accordion.gender-size-conversion-accordion');
    const productCategorySizechart =  document.querySelector('.accordion.product-category-sizechart-accordion');
    const isDynamicFitguideElement = true;
    let url = e.currentTarget.dataset['getcontent'];
    if (url) {
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
          if (data) {
              $('#unit-measure_0').trigger('click');
              if (data.sizeListImageUrl) {
                $('.measuring-img__sketches')
                  .empty()
                  .append('<img src="' + data.sizeListImageUrl + '" alt="img" class="single-image-product" />');
              }
              if (data.sizeListOptions == "<option value=\"uni\">UNI</option>") {
                $('.fitguide__container--desktop').addClass('size-uni-active');
              }
              if (data.sizeListOptions) {
                $("select[name='choose-your-size']")
                  .empty()
                  .append(data.sizeListOptions);
              }
              if (data.tableDetails) {
                $('.measuring-guide__size-table .row')
                  .empty()
                  .append(data.tableDetails);
                $('#fitguide-content-01')
                  .css('display' , 'block');
                $('#fitguide-measurement-button')
                  .addClass('fitguide__tab-button--active')
                  .closest('.tab-button')
                  .css('display' , 'flex');
                if (!data.fitGuideContentAsset) {
                  $('#fitguide-measurement-button')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-12')
                    .css('border-left' , '0');
                  $('.click-to-convert-sizes')
                    .css('display' , 'none');
                }
              }
              if (data.fitGuideContentAsset) {
                isDynamicFitguideElement && sizeConversionAccordion ? sizeConversionAccordion.classList.remove('d-none') : null;
                $('.measuring-guide-container')
                  .empty()
                  .append(data.fitGuideContentAsset);
                $('#fitguide-sizes-button')
                  .closest('.tab-button')
                  .css('display' , 'flex');
                if (!data.tableDetails) {
                  $('#fitguide-sizes-button')
                    .addClass('fitguide__tab-button--active')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-10');
                  $('#fitguide-content-02')
                    .css('display' , 'block');
                } 
              }

              if (data.productCategorySizeChartContentAsset) {
                if(isDynamicFitguideElement) {
                  productCategorySizechart ? productCategorySizechart.classList.remove('d-none') : null;
                } 
                $('.product-category-sizechart .measuring-guide-container')
                  .empty()
                  .append(data.productCategorySizeChartContentAsset);
              }

              if (data.genderlessGuideContentAsset) {
                if(isDynamicFitguideElement) {
                  genderSizeConversionAccordion ? genderSizeConversionAccordion.classList.remove('d-none') : null;
                } 
                $('.fitguige-sizes .measuring-guide-container')
                  .empty()
                  .append(data.genderlessGuideContentAsset);
              }
              if(data.bodyMeasurementsData && Object.keys(data.bodyMeasurementsData).length > 0) {
                const bodyMeasurementContent = bodyMeasurementTemplate(data.bodyMeasurementsData);
                if(bodyMeasuresAccordion) {
                  bodyMeasuresAccordion.classList.remove('d-none');
                }
                $('#body-measures .measuring-guide-container').empty()
                .append(bodyMeasurementContent);

                bodyMeasurementSwitchButtons = document.querySelectorAll('.body-measures-accordion .mm-switch .mm-switch__toggle');
                productMeasurementSwitchButtons = document.querySelectorAll('.product-measures-accordion .mm-switch .mm-switch__toggle');
                bodyMeasurementSwitchButtons.forEach(btn => toggleButtonClick(btn));
                productMeasurementSwitchButtons.forEach(btn => toggleButtonClick(btn));
              }
              if(isDynamicFitguideElement) {
                if(Object.keys(data.fitGuide).length > 0) {
                  productMeasuresAccordion ? productMeasuresAccordion.classList.remove('d-none') : null;
                }
                columnAndRowHighlight();
              }
            }
        },
        error: (error) => {
          alert('error');
        },
      });
    }
  });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
 function createErrorNotification(message) {
  let errorHtml =
    `<div class="cart-error-messaging cart-error mm-form-message -danger">
      <div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">
        ${message}
      </div>
    </div>`;

  $('.cart-error').append(errorHtml);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
 function parseHtml(html) {
  let $html = $('<div>').append($.parseHTML(html));
  let body = $html.find('.product-quickview');
  let footer = $html.find('.modal-footer').children();
  let notifyMeModal = $html.find('.notify-me-container').children();

  return { body: body, footer: footer, notifyMeModal: notifyMeModal };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
 function fillModalElement(editProductUrl) {
  $('.modal-body').spinner().start();
  $.ajax({
    url: editProductUrl,
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      document.getElementById('main-overlay').style.display = 'none';
      document.getElementById('main-overlay').classList.add('no-top');
      document.querySelector('body').style.overflow = 'hidden';
      document.querySelector('body').style.height = '100vh';
      let parsedHtml = parseHtml(data.renderedTemplate);
      $('#editProductModal .modal-body').empty();
      $('#editProductModal .modal-body').html(parsedHtml.body);
      $('#editProductModal .modal-footer').html(parsedHtml.footer);
      $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
      $('#editProductModal .enter-message').text(data.enterDialogMessage);
      $('#editProductModal')[0].classList.add('show');
      $('#notify-me-modal .notify-me-container').html(parsedHtml.notifyMeModal);
      document.getElementById('cart-show').style.height = '100%';
      $('body').trigger('editproductmodal:ready');
      bindEventOpenFitGuide();
      $.spinner().stop();
    },
    error: function () {
      $.spinner().stop();
    },
  });
}

function getModalHtmlElement() {
  if ($('#editProductModal').length !== 0) {
    $('#editProductModal').remove();
  }
  let htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="editProductModal" role="dialog">' +
    '<div class="edit-modal-container">' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    ' <button type="button" class="close pull-right" data-dismiss="modal">' +
    '      <div id="close-edit-product-modal" class="modal-close" role="button" tabindex="0" aria-label="Close dialog" data-dismiss="modal" modal-close></div>' +
    ' </button>' +
    '</div>' +
    '<div class="horizontal-row edit-product-modal-header-bottom"></div>' +
    '<div class="modal-body"></div>' +
    '<div class="modal-footer"></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $('body').append(htmlString);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
 function updateApproachingDiscounts(approachingDiscounts) {
  let html = '';
  $('.approaching-discounts').empty();
  if (approachingDiscounts.length > 0) {
    approachingDiscounts.forEach(function (item) {
      html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
    });
  }
  $('.approaching-discounts').append(html);
}
/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.shipping-cost').empty().append(data.totals.totalShippingCost);
  $('.tax-total').empty().append(data.totals.totalTax);
  $('.grand-total').empty().append(data.totals.grandTotal);
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart-quantity').empty().append(data.numItems);
  $('.minicart-link').attr({
    'aria-label': data.resources.minicartCountOfItems,
    title: data.resources.minicartCountOfItems,
  });
  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.order-discount').removeClass('hide-order-discount');
    $('.order-discount-total')
      .empty()
      .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.order-discount').addClass('hide-order-discount');
  }

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total')
      .empty()
      .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  data.items.forEach(function (item) {
    if (item.renderedPromotions) {
      $('.item-' + item.UUID)
        .empty()
        .append(item.renderedPromotions);
    }
    if (item.priceTotal && item.priceTotal.renderedPrice) {
      $('.item-total-' + item.UUID)
        .empty()
        .append(item.priceTotal.renderedPrice);
    }
  });
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
  let lineItem;
  let messages = '';

  for (let i = 0; i < data.items.length; i++) {
    if (data.items[i].UUID === uuid) {
      lineItem = data.items[i];
      break;
    }
  }

  // $('.availability-' + lineItem.UUID).empty();

  if (lineItem.availability) {
    if (lineItem.availability.messages) {
      lineItem.availability.messages.forEach(function (message) {
        messages += '<p class="line-item-attributes">' + message + '</p>';
      });
    }

    if (lineItem.availability.inStockDate) {
      messages += '<p class="line-item-attributes line-item-instock-date">' + lineItem.availability.inStockDate + '</p>';
    }
  }

  // $('.availability-' + lineItem.UUID).html(messages);
}


function updateDDDcart(data, clickedProduct) {
 var dddContainer = $('.productid-'+clickedProduct).find('.cart-item-dynamic-delivery-date .bag-product__shipping-text .info-ddd-container');
 var dddToolpitContainer = $('.productid-'+clickedProduct).find('.cart-item-dynamic-delivery-date .bag-product__shipping-text .tooltip');
 dddContainer.html('');
 if(data.cartDDDRequest && data.cartDDDRequest.itemEDD) {
    for (let i = 0; i < data.cartDDDRequest.itemEDD.length; i++) {
      let item = data.cartDDDRequest.itemEDD[i];
      let shippingMethodId = item.ShippingMethodId ? item.ShippingMethodId.toLowerCase() : '';
      if (shippingMethodId.includes('standard') || shippingMethodId.includes('ground')) {
        if(item.itemId === data.newProductId) {
          dddContainer.empty().append('<div class="cart-dynamic-delivery-date">'+ item.cartMsg + '</div>');
        }
      } else {
        dddToolpitContainer[0].dataset.text = item.cartMsg;
        if (dddToolpitContainer[0].classList.contains('d-none') && data.cartDDDRequest.itemEDD.length > 1) {
          dddToolpitContainer[0].classList.remove('d-none');
        }
      }
    }
    if (data.cartDDDRequest.itemEDD.length < 2 && dddContainer.length > 0) {
      dddToolpitContainer[0].classList.add('d-none');
    }
 }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
  let lineItem = findItem(data.cartModel.items, function (item) {
    return item.UUID === uuid;
  });

  if (lineItem.variationAttributes) {
    let colorAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'color';
    });

    if (colorAttr) {
      let colorSelector = '.Color-' + uuid;
      let newColor = 'Color: ' + colorAttr.displayValue;
      $(colorSelector).text(newColor);
    }

    let sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'size';
    });

    if (sizeAttr) {
      let sizeSelector = '.Size-' + uuid;
      let newSize = 'Size: ' + sizeAttr.displayValue;
      $(sizeSelector).text(newSize);
    }

    let imageSelector = '.card.product-info.uuid-' + uuid + ' .item-image > img';
    $(imageSelector).attr('src', lineItem.images.small[0].url);
    $(imageSelector).attr('alt', lineItem.images.small[0].alt);
    $(imageSelector).attr('title', lineItem.images.small[0].title);
  }

  if (lineItem.options && lineItem.options.length) {
    let option = lineItem.options[0];
    let optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
    $(optSelector).data('value-id', option.selectedValueId);
    $(optSelector + ' .line-item-attributes').text(option.displayName);
  }

  let qtySelector = '.quantity[data-uuid="' + uuid + '"]';
  $(qtySelector).val(lineItem.quantity);
  $(qtySelector).data('pid', data.newProductId);

  $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

  let priceSelector = '.line-item-price-' + uuid + ' .sales .value';
  $(priceSelector).text(lineItem.price.sales.formatted);
  $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

  if (lineItem.price.list) {
    let listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
    $(listPriceSelector).text(lineItem.price.list.formatted);
    $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
  }
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error) {
    if (data.valid.message) {
      let errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        data.valid.message +
        '</div>';

      $('.cart-error').append(errorHtml);
    } else {
      $('.cart')
        .empty()
        .append('<div class="row"> ' + '<div class="col-12 text-center"> ' + '<h1>' + data.resources.emptyCartMsg + '</h1> ' + '</div> ' + '</div>');
      $('.number-of-items').empty().append(data.resources.numberOfItems);
      $('.minicart-quantity').empty().append(data.numItems);
      $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
      });
      $('.minicart .popover').empty();
      $('.minicart .popover').removeClass('show');
    }

    $('.checkout-btn').addClass('disabled');
  } else {
    $('.checkout-btn').removeClass('disabled');
  }
}


/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
 function findItem(array, match) {
  for (let i = 0, l = array.length; i < l; i++) {
    if (match.call(this, array[i])) {
      return array[i];
    }
  }
  return null;
}




$(document).ready(function () {
  processInclude(require('core/cart/coupon'));
  //processInclude(require('core/product/fitguide')); //process include removed here to prevent double API Call on Margiela PDP/Wishlist/Cart
  processInclude(require('./tooltip'))
  processInclude(require('tealium/tealiumEvents'));

  let isVisible = false;

  const showEtaExtraInfoMessage = (ev) => {
    const etaInfoWrapper = ev.target.closest('.eta-extra-info-wrapper');
    if(etaInfoWrapper) {
      const messageBox = etaInfoWrapper.querySelector('.eta-extra-info-message');
      const messageIconToggler = ev.target.closest('.eta-extra-info-icon');
      if(isVisible) {
        messageBox.classList.remove('visible');
        messageIconToggler.classList.remove('active');
      } else {
        messageBox.classList.add('visible');
        messageIconToggler.classList.add('active');
      }
    }
  }

  if(document.querySelectorAll('.eta-extra-info-icon')) {
    document.querySelectorAll('.eta-extra-info-icon').forEach(i => i.addEventListener('click', function(e) {
      showEtaExtraInfoMessage(e);
      isVisible = !isVisible;
    }));
  }

  $(document.body).on('change',".js-edit-product-footer .quantity-select",function (e) {
    $('.update-cart-url')[0].dataset.selectedQuantity = this.value;
 });

  $('body').on('click', '.update-cart-product-global', function (e) {
    e.preventDefault();
    let updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
    let selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url')[0].dataset.selectedQuantity;
    let selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
    let uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
    let pid = updatedPid;

    let form = {
      uuid: uuid,
      pid: pid,
      quantity: selectedQuantity,
      selectedOptionValueId: selectedOptionValueId
    };

    // $(this).parents('.card').spinner().start();
    if (updateProductUrl) {
      $.ajax({
        url: updateProductUrl,
        type: 'post',
        context: this,
        data: form,
        dataType: 'json',
        success: function (data) {
          document.querySelector('.alert-danger.invalid-selected-product') ? document.querySelector('.alert-danger.invalid-selected-product').classList.add('hidden d-none') : null;
          clickedProduct = document.querySelector('#modal-edit-product .js-remove-from-cart').getAttribute('data-pid');
          $('.modal.is-open [modal-close]').trigger('click');
          $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
          updateCartTotals(data.cartModel);
          updateApproachingDiscounts(data.cartModel.approachingDiscounts);
          updateAvailability(data.cartModel, uuid);
          updateProductDetails(data, uuid);
          if(data.cartDDDRequest) {
            updateDDDcart(data, clickedProduct);
          }

          if (data.uuidToBeDeleted) {
            $('.productuuid-' + data.uuidToBeDeleted).remove();
            let updatedQuantity = '';
            data.cartModel.items.filter(key =>{
              if(key.id == data.newProductId){
                updatedQuantity = key.quantity;
              }
            });
            $('.productuuid-' + uuid).find('.quantity-input').val(updatedQuantity);
          }
          validateBasket(data.cartModel);
          var items = data.cartModel.items;
          for (var i = 0; i < items.length; i++) {
            if (items[i].id === clickedProduct) {
              if (clickedColor == '' ) {
                for (let j = 0; j < items[i].variationAttributes.length; j++) {
                  if (items[i].variationAttributes[j].id === 'color') {
                    clickedColor = items[i].variationAttributes[j].displayValue;
                  } else {
                    clickedSize = items[i].variationAttributes[j].displayValue;
                  }
                }
              }
              if (clickedImage == '') {
                clickedImage = items[i].images.small[0].url;
              }
            }
          }
          if( $('.productid-' + clickedProduct)){
            $('.productid-' + clickedProduct + ' .detail-attribute.color .bag-product__details-value').text(clickedColor);
            $('.productid-' + clickedProduct + ' .detail-attribute.size .bag-product__details-value').text(clickedSize);
            $('.productid-' + clickedProduct + ' .product-image')[0].src = clickedImage + '?sw=170&sh=226';
            let idsTochange = [...document.querySelectorAll(`[data-pid="${clickedProduct}"]`)];
            var quantity;
            for (let quantityValue = 0; quantityValue < data.cartModel.items.length; quantityValue++) {
              if (data.cartModel.items[quantityValue].id === data.newProductId) {
                quantity = data.cartModel.items[quantityValue].quantity;
              }
            }
            $('.productid-' + clickedProduct + ' .quantity-label .quantity-value')[0].innerHTML = quantity;
            idsTochange.forEach((item) => {
             item.setAttribute('data-pid',data.newProductId);
            });

            let classIdsTochange = [...document.querySelectorAll(`.productid-${clickedProduct}`)];
            classIdsTochange.forEach((item) => {
             item.classList.remove(`productid-${clickedProduct}`);
             item.classList.add(`productid-${data.newProductId}`);
            });
          }

          $('body').trigger('cart:update');
         
          // Tealium event "Modify Product Confirm"
          $('body').trigger('cart:productModified', data);
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            if(document.querySelector('.invalid-selected-product')){
              document.querySelector('.invalid-selected-product').textContent=err.responseJSON.errorMessage;
              document.querySelector('.invalid-selected-product').classList.remove('d-none');
            } 
          }
        },
      });
    }
  });

  $('body .cart-body-section .cart-edit-link').on('click', function (e) {
    const $product = $(e.currentTarget);
    clickedProduct = e.currentTarget.closest('li.product-wrapper').classList[2];
    e.preventDefault();
    const pid = $(this).parent().find('.cart-remove-btn').data('pid');
    let editProductUrl = $(this).attr('data-href');

    if (pid) {
      editProductUrl += '&pid=' + pid;
    }

    let errorObj = document.querySelector('.cart-error-messaging');
    if (errorObj) document.querySelector('.cart-error-messaging').classList.add('d-none');
    updatedPid = e.currentTarget.dataset.pid;

    $.ajax({
      url: editProductUrl,
      type: 'GET',
      dataType: 'json',
      data: $product.serialize(),
      beforeSend: function () {
        $.spinner().start();
      },
      success: function (data) {
        if (data.error) {
          $('.promo-code-form .form-control').addClass('is-invalid');
          $product.find('.invalid-feedback').append(data.errorMessage).removeClass('d-none');
        } else {
          // Tealium event "Modify Prodcut Popup Open"
          $('body').trigger('cart:modifyProductOpen');
          getModalHtmlElement();
          fillModalElement(editProductUrl);
        }

        // $('.coupon-code-field').val('');//
        $.spinner().stop();

        setTimeout(function () {
          $('.coupon-code-field').val('');
          $('.promo-code-form .form-control').removeClass('is-valid');
          $('.promo-code-form .form-control').removeClass('is-invalid');
        }, 2000);
      },
      error: function (err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        } else {
          createErrorNotification(err.errorMessage);
          $.spinner().stop();
        }
      },
    });
  });

  $('body').on('click', '.modal-close', function (e) {
    let modalToClose = e.currentTarget.dataset.modalToClose;
    $('#' + modalToClose).removeClass('is-open');
  });
  
  // update cart data on color click
  $('body').on('click', '#edit-product-modal.is-open .color-trigger-cart-update', function (e) {
      const index = e.target;
      const productContainer = index && index.closest('.modal-edit-product.modal-edit-product');

      if(index.classList.contains('disabled')){
        return;
      }
      clickedColor = index.dataset.displayValue;
      // let clickedColorSelector= '.value-' + index.defaultValue + '-selected';
      currentOpenedModal = index && index.closest('.modal-edit-product');
      // const $product = index;
      // let selectedElement = $(clickedColorSelector)[0];

      const colorPidUrl = index && index.getAttribute('data-url');

      if (colorPidUrl) {
        $.ajax({
          url: colorPidUrl,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            updatedPid = data.product.id;
            newUuid = data.product.uuid;
            clickedImage = data.product.swipeableImages.large[0].url;
            updateImages(data.product);
            
            $('#edit-product-modal.is-open .js-select-size').empty();
            for (let i = 0; i < data.product.variationAttributes.length; i++) {
              if (data.product.variationAttributes[i].attributeId == 'color') {
                for (let a = 0; a < data.product.variationAttributes[i].values.length; a++) {
                  var colorID = data.product.variationAttributes[i].values[a].id;
                  if (colorID = index.defaultValue) {
                    document.querySelectorAll('#edit-product-modal.is-open .product-color-variant').forEach(c => c.classList.remove('selected-description'));
                    document.querySelector(`#edit-product-modal.is-open p[data-value-id="value-${colorID}"]`).classList.add('selected-description');
                    document.querySelectorAll('#edit-product-modal.is-open .color-trigger-cart-update').forEach(c => c.checked = false);
                    document.querySelector(`#edit-product-modal.is-open input[data-value-id="value-${colorID}"]`).checked = true;
                    document.querySelectorAll('#edit-product-modal.is-open .modal-edit-product .color-trigger-cart-update').forEach(c => c.classList.remove('selected-color'));
                    document.querySelector(`#edit-product-modal.is-open input[data-value-id="value-${colorID}"]`).classList.add('selected-color');
                  }

                }
              }
              if (data.product.variationAttributes[i].attributeId == 'size') {
                for (let a = 0; a < data.product.variationAttributes[i].values.length; a++) {
                  const option = document.createElement("option");
                  option.value = data.product.variationAttributes[i].values[a].url;
                  option.dataset.attrValue = data.product.variationAttributes[i].values[a].value;
                  option.dataset.attrSelectable = data.product.variationAttributes[i].values[a].selectable;
                  option.classList = (data.product.variationAttributes[i].values[a].selectable == false ? 'disabled' : 'enabled');
                  if ($('#edit-product-modal.is-open .js-select-size').length) {
                    let text = ' ' + $('#edit-product-modal.is-open .js-select-size')[0].dataset.notavailable;
                    let message = (data.product.variationAttributes[i].values[a].selectable == false ? text : '');
                    option.innerText = data.product.variationAttributes[i].values[a].displayValue + message;
                    $('#edit-product-modal.is-open .js-select-size').append(option);
                    if(data.product.variationAttributes[i].values[a].selected) {
                      option.selected = true
                    }  
                  }
                }
              }
            }

            if(!data.product.available){
              document.querySelector('.add-to-cart-switch').classList.remove('-active');
              document.querySelector('.size-switch').classList.add('-active');
              document.querySelector('.update-cart-product-global').disabled = true;
            } else {
              document.querySelector('.add-to-cart-switch').classList.add('-active');
            document.querySelector('.size-switch').classList.remove('-active');
            document.querySelector('.update-cart-product-global').disabled = false;
            }

          },
          error: function (err) {
            if (err.responseJSON.redirectUrl) {
              window.location.href = err.responseJSON.redirectUrl;
            } else {
              createErrorNotification(err.responseJSON.errorMessage);
            }
          },
        });
      }
  });

  document.addEventListener('change', (e) => {
    if(e.target.id=='size-2' && $('#edit-product-modal.is-open').length > 0){
      const index = e.target.selectedIndex;
      if (e.target.classList.contains('wishlist__select')) {
        return;
      }
      clickedColor = $('#edit-product-modal.is-open .selected-description')[0].innerText;
      let clickedColorValue = document.querySelector('#edit-product-modal.is-open .modal-edit-product .color-trigger-cart-update.selected-color').value;
      let colorContainer = e.target.closest('#edit-product-modal.is-open .modal-edit-product').querySelector('.product-variants .product-variants-box');
      const selectedElement = e.target.options[index];
      if(selectedElement.classList.contains('disabled')){
        document.querySelector('#edit-product-modal.is-open .add-to-cart-switch').classList.remove('-active');
        document.querySelector('#edit-product-modal.is-open .size-switch').classList.add('-active');
        document.querySelector('#edit-product-modal.is-open .update-cart-product-global').disabled = true;
        let colorsRadio = colorContainer.querySelectorAll('#edit-product-modal.is-open .mm-color-swatch__inner');
        colorsRadio.forEach((colorInput) => {
          let currentUrl = selectedElement.value;
          let newURL = currentUrl.indexOf('_color='+clickedColorValue) > -1 ? currentUrl.replace('_color=' + clickedColorValue, '_color=' + colorInput.value) : '';
          newURL ? colorInput.setAttribute('data-href', newURL) : '';
          newURL ? colorInput.setAttribute('data-url', newURL) : '';
        });
        return;
      }
      clickedSize = selectedElement.dataset.attrDisplayValue ? selectedElement.dataset.attrDisplayValue : selectedElement.dataset.attrValue;
      const $product = selectedElement;
      const sizePidUrl = selectedElement.value;

      if (sizePidUrl) {
        $.ajax({
          url: sizePidUrl,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            updatedPid = data.product.id;
            newUuid = data.product.uuid;
            clickedImage = data.product.swipeableImages.large[0].url;

            document.querySelector('#edit-product-modal.is-open .add-to-cart-switch').classList.add('-active');
            document.querySelector('#edit-product-modal.is-open .size-switch').classList.remove('-active');
            document.querySelector('#edit-product-modal.is-open .update-cart-product-global').disabled = false;
            updateColorUrl(colorContainer, data.product.variationAttributes[0]);            
          },
          error: function (err) {
            if (err.responseJSON.redirectUrl) {
              window.location.href = err.responseJSON.redirectUrl;
            } else {
              createErrorNotification(err.responseJSON.errorMessage);
            }
          },
        });
      }
    }
  });

});

function updateColorUrl(colorContainer, attrs) {
  attrs.values.forEach((attr) => {
    let $attributeValues = colorContainer.querySelector('#edit-product-modal.is-open .modal-edit-product .mm-color-swatch__inner.value-' + attr.id);
    $attributeValues.setAttribute('data-href', attr.url);
    $attributeValues.setAttribute('data-url', attr.url);
  });

}

$(document).on('DOMNodeInserted', function(e) {
  if($(e.target).hasClass('paypal-checkout-sandbox')){
    if(!document.activeElement.parentElement.parentElement.classList.contains('paypal-cart-button-minicart')){
        fastCheckout('paypal', 'shoppingbag');
      }
  }
});

$('body').on('click', '.apple-pay-cart-button', function() {
  fastCheckout('applepay', 'shoppingbag');
});


$('body').on('click', '#edit-product-modal .edit-product-modal', function() {
  $('body')[0].style.overflowY = 'scroll';
});

$('body').on('click', '.js-remove-from-cart-label', function() {
  $('#edit-product-modal.is-open .js-remove-from-cart').click();
});

// $('body').on('click', '.mm-button.cart-lineitem-recommendation', function(e) {
//   var selector = '.' + e.currentTarget.dataset.actionPid;
//   if ($(selector)[0].classList.contains('visually-hidden')) {
//     $(selector)[0].classList.remove('visually-hidden');
//   } else {
//     $(selector)[0].classList.add('visually-hidden');
//   }
// });

function fastCheckout(cartType, buttonPosition) {
  var fastCheckoutUrl = $(".track-fast-checkout-url").val();
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;
  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      data: { fastPayment: fastCheckoutData},
      success: function (data) {
        $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
      }
  });
 }

}

$('body').on('click', '.cart-checkout-buttons-wrapper .checkout-btn', function() {
  var fastCheckoutUrl = $('.remove-track-fast-checkout-url').val();
  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      success: function (data) {
        $('.remove-track-fast-checkout-url').data('fastcheckout', false);
      }
  });
 }
});



